import { property, supertypeClass } from '@haventech/amorphic';
import { Product } from '../../../common/js/static/Product';
import { MMDirectPolicy } from '../mmdirect_subclasses/MMDirectPolicy';
import { LifeBridgeCustomer } from './LifeBridgeCustomer';

@supertypeClass({ toClient: true, toServer: true })
export class LifeBridgePolicy extends MMDirectPolicy {
  @property({ getType: () => LifeBridgeCustomer })
  customer: LifeBridgeCustomer;

  constructor() {
    super();
  }

  static new(customer, type?) {
    return new LifeBridgePolicy().init(customer, type);
  }

  init(customer, type) {
    super.init(customer, type);

    this.product = Product.products.ET10.code;
    return this;
  }

  // if LifeBridge, owner is always Trust
  ownerTypeValues() {
    const values = [];
    values.push('trust');
    return values;
  }
}
